<div class="container-fluid"
     *ngIf="!messagingService.hasMessagingNumber() && !messagingService.getNumbersInProgress && processingNumbers.length === 0">
  <div class="row">
    <div class="col-sm-12">
      <mat-card appearance="outlined" style="margin-top: 30px">
        <mat-card-header></mat-card-header>
        <mat-card-content>
          <div class="no-messages-container" style="text-align: center">
            <mat-icon class="icon-40">perm_phone_msg</mat-icon>
            <h2>You haven't added any Pro Business SMS numbers</h2>
            <p>You must enable numbers you'd like to use for Pro Business SMS.</p>
            <span
              *ngIf="!hasPhoneNumbersEditRight"> Contact your company administrator to setup messaging number.</span>
            <div *ngIf="hasPhoneNumbersEditRight">
              <button mat-flat-button color="primary" (click)="addNewSmsNumber()">
                <span class="center-text">Add New Phone Number</span>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<div class="container-fluid"
     *ngIf="!messagingService.hasMessagingNumber() && !messagingService.getNumbersInProgress && processingNumbers.length > 0">
  <div class="row">
    <div class="col-sm-12">
      <mat-card appearance="outlined" style="margin-top: 30px">
        <mat-card-header></mat-card-header>
        <mat-card-content>
          <div class="no-messages-container" style="text-align: center">
            <mat-icon class="icon-40">perm_phone_msg</mat-icon>
            <h2>Activating SMS service is progress</h2>
            <p>SMS service activation could take up to 12h.</p>
            <div *ngFor="let number of processingNumbers" fxLayout="row" fxLayoutAlign="center center"
                 fxLayoutGap="5px">
              <span style="font-weight: bold">{{ number.number | phoneNumber }}</span>
              <span>Status: <span style="font-weight: bold">{{ number.smsServiceStatus }}</span></span>
            </div>
            <mat-progress-spinner style="margin: 50px auto" [strokeWidth]="3" mode="indeterminate"
                                  [diameter]="150"></mat-progress-spinner>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<mat-drawer-container #mainContainer class="messaging-container"
                      *ngIf="messagingService.hasMessagingNumber() && !messagingService.getNumbersInProgress">
  <mat-drawer #threadsDrawer [mode]="sidenavMode" [opened]="showThreads" (opened)="onThreadsMenuOpened()"
              [disableClose]="sidenavMode === 'side'">
    <div class="actions-container">
      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="isMobileView">
        <button mat-icon-button class="button-40" (click)="threadsDrawer.close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-form-field class="selected-number-dropdown no-underline no-hint">
        <mat-select panelClass="selected-number-popup"
                    [(ngModel)]="messagingService.selectedMessagingNumber"
                    (ngModelChange)="onPhoneNumberValueChange($event)"
                    (openedChange)="onPhoneNumberOpenedChange($event)"
                    [hideSingleSelectionIndicator]="true"
        >
          <mat-select-trigger>
            <span class="selected-number-name" fxLayout="row">
              <span
                style="display: inline-block; max-width: 235px; overflow: hidden; text-overflow: ellipsis">{{ messagingService.selectedMessagingNumber?.userName }}</span>
              <app-explanation
                *ngIf="messagingService.selectedMessagingNumber?.assignedUsers && messagingService.selectedMessagingNumber?.assignedUsers.length > 1">
                <label>Messaging Assigned To:</label><br />
                <span *ngFor="let name of messagingService.selectedMessagingNumber?.assignedUsers">
                  {{ name }}<br>
                </span>
              </app-explanation>
            </span>
            <span class="selected-number light-text"
                  [class.warning]="!messagingService.selectedMessagingNumber?.campaignId">
              <span
                *ngIf="messagingService.selectedMessagingNumber?.campaignId">{{ messagingService.selectedMessagingNumber?.phoneNumber | phoneNumber }}</span>
              <app-explanation *ngIf="!messagingService.selectedMessagingNumber?.campaignId"
                               icon="priority_high"
                               label="{{messagingService.selectedMessagingNumber?.phoneNumber | phoneNumber}}"
              >
                <span>
                  This phone number is not 10DLC registered and may be blocked from sending messages.
                  <a class="btn-link" role="button" (click)="openSupportWidget()">Please contact us to register this number</a>.
                </span>
              </app-explanation>
            </span>
          </mat-select-trigger>
          <mat-button-toggle-group class="show-only-my-numbers" name="showOnlyMyNumbers"
                                   [(value)]="messagingService.showOnlyMyNumbers" *ngIf="isAdmin"
                                   style="width: 100%; margin-bottom: 5px;">
            <mat-button-toggle style="width: 50%" [value]="true" (click)="showAllNumbers(true)">My Numbers
            </mat-button-toggle>
            <mat-button-toggle style="width: 50%" [value]="false" (click)="showAllNumbers(false)">All Numbers
            </mat-button-toggle>
          </mat-button-toggle-group>
          <mat-option *ngFor="let option of messagingService.filteredMessagingNumbers" [value]="option"
                      (click)="onPhoneNumberClicked(option)"
                      style="line-height: 1; height: 4em" class="selected-number-popup">
            <span style="font-weight: 600;font-size: 16px;line-height: 20px;">
              {{ option.userName }}
            </span>
            <span style="font-weight: normal; font-size: 13px; line-height: 16px; padding-left: 0; display: block"
                  [matBadge]="option.badge"
                  [matBadgeHidden]="!option.badge || option.badge <= 0"
                  matBadgePosition="after"
                  matBadgeColor="warn">
              {{ option.phoneNumber | phoneNumber }}
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="hasEditAccess && messagingService.selectedMessagingNumber?.allowSend && !limitsReached">
        <button mat-flat-button color="primary" class="compose-btn" (click)="onNewMessage($event)">
          <mat-icon>add_circle</mat-icon>
          Compose A New Message
        </button>
      </div>

      <mat-form-field class="sms-search-field no-underline" appearance="outline" *ngIf="routedPhoneNumber">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" placeholder="Search message" autocomplete="off" [(ngModel)]="searchTextInternal"
               (input)="onSearchTextChange($event.target['value'])">
        <a mat-icon-button *ngIf="searchText" matSuffix aria-label="Clear" class="button-40"
           (click)="clearSearch($event)">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
    </div>

    <div class="threads-container">
      <app-pro-phone-number-group-v2 #threadCmp
                                     [selectedNumber]="routedPhoneNumber"
                                     [selectedTheadKey]="routedThreadKey"
                                     [searchText]="searchText"
                                     [hasContactsEditRight]="hasContactsEditRight"
                                     [hasContactsModule]="hasContactsModule"
                                     [defaultSortType]="smsThreadSortType"
                                     (selectedThreadChangeEvent)="onSelectedThreadChanged($event)"
      ></app-pro-phone-number-group-v2>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <form class="messages-form" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
      <div class="messages-container" fxLayout="column" [ngClass]="{'is-mobile-view': isMobileView}">
        <div class="messages-header" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="10px">
          <button mat-icon-button class="button-40 rect-btn active-accent" type="button"
                  *ngIf="isMobileView" (click)="threadsDrawer.toggle()" fxFlexOrder="1">
            <mat-icon>menu_open</mat-icon>
          </button>
          <div fxLayout="row" fxLayoutAlign="start center"
               fxFlex fxFlex.xs="100" fxFlexOffset.xs="10px"
               fxLayoutGap="10px" fxFlexOrder="2" fxFlexOrder.xs="3">
            <label>To:</label>
            <app-pro-thread-recipients class="messaging-recipients" formControlName="clientPhoneNumbers" fxFlex
                                       (ngModelChange)="clientPhoneNumbersChanged($event)"
                                       placeholder="Enter phone number"></app-pro-thread-recipients>
          </div>

          <button mat-icon-button color="warn" class="button-40 rect-btn active-warn" fxFlexOrder="3"
                  type="button"
                  fxFlexOrder.xs="2"
                  title="Delete Conversation"
                  (click)="onDeleteClick()"
                  *ngIf="hasDeleteAccess && messagingService.selectedMessagingNumber?.allowSend && !!selectedGroup && !!selectedGroup?.groupKey">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <div class="messages-holder" fxFlex>
          <app-pro-messages-grid-v2
            [selectedPhoneNumber]="routedPhoneNumber"
            [selectedThreadKey]="routedThreadKey"
            [searchText]="searchText"
            (lastIncomingMessageEvent)="onLastIncomingMessage($event)"
          ></app-pro-messages-grid-v2>
        </div>
        <div class="messages-actions"
             *ngIf="!(messagesDatasource.loading$ | async) && !messagingService.getNumbersInProgress && selectedGroup">
          <div class="messages-footer"
               *ngIf="hasEditAccess && messagingService.selectedMessagingNumber?.allowSend && !selectedGroup?.broadcastId && !limitsReached">
            <div class="messages-form" fxLayout="column" fxLayoutGap="10px">
              <div class="preview-attachment" *ngIf="previewFileName"
                   fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="center start">
                <div fxFlex fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="space-around center">
                  <img [src]="previewUrl" alt="preview" *ngIf="previewUrl">
                  <div>{{ previewFileName }}</div>
                </div>
                <button type="button" mat-icon-button class="button-40" (click)="removeAttachment()"
                        matTooltip="Remove attachment">
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <div class="actions-row" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start start"
                   [ngClass]="{'is-mobile-view': isMobileView}">
                <button type="button" mat-icon-button class="button-40 rect-btn"
                        [ngClass]="{'message-waba-btn active': form.getRawValue().type === 'waba', 'active-accent': form.getRawValue().type === 'text'}"
                        [matMenuTriggerFor]="messageTypeMenu"
                        *ngIf="providerTypes.length > 1">
                  <i class="fa-icon fa-solid fa-comment-sms" *ngIf="form.getRawValue().type === 'text'"></i>
                  <i class="fa-icon fa-brands fa-whatsapp" *ngIf="form.getRawValue().type === 'waba'"></i>
                </button>
                <mat-menu #messageTypeMenu="matMenu" class="custom-menu">
                  <button type="button" mat-menu-item (click)="selectCommunicationType('text')"
                          fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon fontSet="fas" fontIcon="fa-comment-sms"></mat-icon>
                    SMS/MMS
                  </button>
                  <button type="button" mat-menu-item (click)="selectCommunicationType('waba')"
                          fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon fontSet="fab" fontIcon="fa-whatsapp"></mat-icon>
                    WhatsApp
                  </button>
                </mat-menu>

                <input #fileInput id="upload-mms" style="display: none" class="file-input" type="file"
                       (change)="fileChangeEvent($event)"
                       placeholder="Choose a file..." />

                <div fxFlex fxLayout="row" fxLayoutAlign="center center" *ngIf="!canSendMessage()">
                  <button type="button" color="primary" mat-stroked-button (click)="onSelectWhatsAppTemplate()"
                          style="line-height: 38px;">
                    Select Template
                  </button>
                </div>

                <div fxFlex fxLayout="row" fxLayoutAlign="start center"
                     [ngClass]="{'hidden': !canSendMessage()}"
                     [ngStyle]="{'display': canSendMessage() ? 'flex' : 'none'}">

                  <div fxLayout.lt-sm="row wrap" fxFlex fxLayoutAlign.lt-sm="end center" fxLayout="row"
                       fxLayoutAlign="start center">
                    <mat-form-field appearance="outline" fxFlex fxFlex.lt-sm="100" class="message-text-field">
                      <textarea #textInput
                                matInput
                                [cdkTextareaAutosize]="true"
                                [cdkAutosizeMinRows]="1"
                                [cdkAutosizeMaxRows]="5"
                                formControlName="message"
                                (paste)="onFilePaste($event)" (focus)="markUnreadMessages()"
                                (keypress)="msgKeyPress($event)" placeholder="Enter your message">
                      </textarea>
                    </mat-form-field>

                    <button mat-icon-button type="button" class="button-40" (click)="fileInput.click()" fxLayout="row">
                      <mat-icon>attach_file</mat-icon>
                    </button>

                    <button mat-icon-button type="button" class="button-40" (click)="templateTrigger.click()"
                            fxLayout="row">
                      <mat-icon>quickreply</mat-icon>
                      <app-messaging-select-template-v2 #templateTrigger
                                                        style="visibility: hidden; height: 1px; width: 1px; position: absolute"
                                                        (selectedEvent)="onTemplateSelected($event)"></app-messaging-select-template-v2>
                    </button>

                    <button mat-icon-button type="button" class="button-40" (click)="onSelectWhatsAppTemplate()"
                            fxLayout="row"
                            *ngIf="form.getRawValue().type === 'waba'">
                      <i class="fa-icon fa-brands fa-whatsapp"></i>
                    </button>
                  </div>
                </div>
                <button type="submit" mat-icon-button class="button-40 rect-btn message-send-btn active" color="primary"
                        matTooltip="Send Message">
                  <mat-icon *ngIf="!submitting">send</mat-icon>
                  <mat-spinner *ngIf="submitting" diameter="24" strokeWidth="2"></mat-spinner>
                </button>
              </div>
            </div>
            <div class="file-drop-area" appDroppable (dropped)="dropFile($event)">
              <div>Drop File Here</div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-drawer-content>
</mat-drawer-container>
